jQuery(function($) {
  'use strict';

  if ($('.js-coll-parent:not(.editmode)').length) {
    $('.js-coll-parent').on('click', function() {
      var item = $(this),
          answer = $(this).siblings('.js-coll-child');

      if (item.hasClass('expanded')) {
        item.siblings('.js-coll-child').removeAttr('style');
        item.removeClass('expanded');
      } else {
        answer.css('max-height', answer.prop('scrollHeight') + 48);
        item.addClass('expanded');
      }
      return false;
    });
  }
});
